<script>
import ServerSideDatatable from '../../ServerSideDatatable/index.vue'
import DatePicker from '../../inputs/DatePicker.vue'
import TextInput from '../../inputs/TextInput.vue'
import Selector  from '../../inputs/Selector.vue'
import axios from 'axios'

export default {
  props: {
    establecimientos: {
      type: Array,
      default: () => [],
    },
    profesionales: {
      type: Array,
      default: () => [],
    },
    tipos_citas: {
      type: Array,
      default: () => [],
    },
    estados: {
      type: Array,
      default: () => [],
    },
    fecha_inicio_inicial: {
      type: String,
      default: null,
    },
    fecha_termino_inicial: {
      type: String,
      default: null,
    },
    csv_action: {
      type: String,
      default: null,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ServerSideDatatable,
    DatePicker,
    TextInput,
    Selector,
  },
  data() {
    return {
      fecha_inicio: this.fecha_inicio_inicial,
      fecha_termino: this.fecha_termino_inicial,
      rut_profesional: null,
      id_establecimiento: null,
      ids_horas_seleccionadas: [],
    }
  },
  computed: {
    tableHeaders() {
      return [
        { key: 'fecha', label: 'Fecha', sortable: true, sort_key: 'hora_inicio' },
        { key: 'hora', label: 'Hora', sortable: true, sort_key: 'hora_inicio' },
        { key: 'codigo_profesional', label: 'Código profesional', sortable: true, sort_key: 'cod_profesional' },
        { key: 'nombre_profesional', label: 'Profesional', sortable: true, sort_key: 'horas.nombre_profesional' },
        { key: 'codigo_establecimiento', label: 'Código establecimiento', sortable: true, sort_key: 'cod_establecimiento' },
        { key: 'establecimiento', label: 'Establecimiento', sortable: true, sort_key: 'establecimientos.nombre' },
        { key: 'rut_paciente', label: 'Rut paciente', sortable: true, sort_key: 'rut_paciente' },
        { key: 'nombre_paciente', label: 'Paciente', sortable: true, sort_key: 'nombre_paciente' },
        { key: 'tipo_cita', label: 'Tipo cita', sortable: true, sort_key: 'nombre_tipo_cita' },
        { key: 'especialidad', label: 'Especialidad', sortable: true, sort_key: 'tipo_atencion' },
        { key: 'estado', label: 'Estado', sortable: true, sort_key: 'estados_horas.nombre' },
      ]
    },
    fetchParams() {
      return {
        fecha_inicio: this.fecha_inicio,
        fecha_termino: this.fecha_termino,
        documento_profesional: this.rut_profesional,
        id_establecimiento: this.id_establecimiento,
      }
    },
    establecimientos_options() {
      return this.establecimientos?.map(({ id, nombre, uuid }) => ({ 
        id, 
        label: uuid ? `${uuid} - ${nombre}` : nombre 
      })) ?? []
    },
    profesionales_options() {
      return this.profesionales?.map(({ documento, nombrecompleto }) => ({ 
        id: documento, 
        label: `${documento} - ${nombrecompleto}`
      })) ?? []
    },
  },
  methods: {
    can(permission) {
      if(!this.user) return false
      return this.user?.roles?.includes('ADM') || this.user.permissions?.includes(permission)
    },
    isRowDisabled(row) {
      // Only enable rows with "Agendada" or "Confirmada" status
      if (row.estado !== 'Agendada' && row.estado !== 'Confirmada') {
        return true
      }
      // Check if fecha is in the past
      if (row.hora_inicio) {
        const rowDate = new Date(row.hora_inicio.replace(' ', 'T'))
        const now = new Date()
        if (!Number.isNaN(rowDate.getTime()) && rowDate < now) {
          return true
        }
      }
      return false
    },
    loadRows() {
      this.$refs.tableRef.startGetData()
    },
    handleBuscarClick() {
      this.loadRows()
    },
    handleBloquearClick() {
      if(!this.ids_horas_seleccionadas.length) {
        this.$swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Oops...',
            text: "Selecciona una o mas horas",
            showConfirmButton: true,
        });
        return
      }
      this.$swal.fire({
          title: '¿Seguro desea bloquear estas horas?',
          showDenyButton: true,
          confirmButtonText: 'Si',
          denyButtonText: `No`,
      }).then((result) => {
          if (result.isConfirmed) {
            this.bloquear()
          }
      })
    },
    bloquear() {
      const ids_horas = this.ids_horas_seleccionadas
      axios.post('horas/bloquear', {ids_horas})
        .then(response => {
          const { ids_horas_bloqueadas, ids_horas_no_bloqueadas } = response.data
          let mensaje = ''
          let titulo = ''
          let icono = ''
          if(ids_horas_bloqueadas.length === ids_horas.length) {
            icono = 'success'
            titulo = '¡Éxito!'
            mensaje = 'Las horas seleccionadas fueron bloqueadas'
          } else if(ids_horas_bloqueadas.length === 0) {
            icono = 'error'
            titulo = '¡Error!'
            mensaje = 'Ninguna hora fue bloqueada'
          } else {
            icono = 'warning'
            titulo = '¡Atención!'
            mensaje = `Se bloquearon las horas con código [${ids_horas_bloqueadas.join(', ')}]  
            y no se bloquearon las horas con código [${ids_horas_no_bloqueadas.join(', ')}]
            `
          }
          this.loadRows()
          this.$swal.fire({
            position: 'center',
            icon: icono,
            title: titulo,
            text: mensaje,
            showConfirmButton: true,
          });
      }).catch(error => {
          console.log(error);
      })      
    }
  }
}
</script>

<template>
<div>
    <div>
        <div class="ibox sombra-light">
            <div class="ibox-title">
                <h5>
                    <i class="fal fa-clock"></i> Gestión de horas
                </h5>
            </div>
            <div class="ibox-content">
                <div class=" mt-3">
                    <!-- Filtros -->
                    <div class="row">
                      <div class="col-md-6">
                        <DatePicker
                          v-model="fecha_inicio"
                          format="DD-MM-YYYY"
                          title="Fecha inicio"
                          placeholder="Fecha inicio"
                        />
                      </div>
                      <div class="col-md-6">
                        <DatePicker
                          v-model="fecha_termino"
                          format="DD-MM-YYYY"
                          title="Fecha término"
                          placeholder="Fecha término"
                        />
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-6">
                        <Selector 
                          title="Establecimiento"
                          placeholder="Establecimiento"
                          v-model="id_establecimiento"
                          :options="establecimientos_options"
                          clearable
                        />
                      </div>
                      <div class="col-md-6">
                        <Selector 
                          v-model="rut_profesional"
                          title="Profesional"
                          placeholder="Seleccione profesional"
                          :options="profesionales_options"
                          clearable
                        />
                      </div>
                    </div>
                    <!-- Acciones -->
                    <div class="row mt-3">
                      <div class="col-md-2">
                        <button 
                          type="button"
                          class="btn btn-primary btn-block"
                          @click="handleBuscarClick"
                        >Buscar
                        </button>
                      </div>
                      <div class="col-md-2" v-if="can('horas.bloquear')">
                        <button class="btn btn-secondary btn-block" @click="handleBloquearClick">
                          Bloquear
                        </button>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-12">
                        <ServerSideDatatable
                          ref="tableRef" 
                          :table-headers="tableHeaders"
                          :fetch-config="{
                            url: '/admin/configurar/horas/buscar',
                            params: fetchParams,
                          }"
                          :csvAction="{
                            isActive: true,
                            baseURL: csv_action,
                            params: fetchParams,
                          }"
                          :disableActions="true"
                          :disableRequestOnMounted="true"
                          @changeSelectedRows="ids_horas_seleccionadas = $event"
                          rowKey="id"
                          :isRowDisabled="isRowDisabled"
                        >
                          <!-- afterRequest: afterRequest, -->
                          <!-- @changeIsLoadingData="setAreLoadingCitas($event)" -->
                          <!-- @changeData="setCitas($event)" -->
                          <template v-slot:actions="{ row: cita }">
                              <OpcionesButton :cita="cita" />
                          </template>

                          <!-- Columns -->
                          <template v-slot:column-fecha="{row}">
                            <span v-if="row.hora_inicio">{{ row.hora_inicio.split(' ')[0] }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-hora="{row}">
                            <span v-if="row.hora_inicio">{{ row.hora_inicio.split(' ')[1] }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-codigo_establecimiento="{row}">
                            <span v-if="row.cod_establecimiento">{{ row.cod_establecimiento }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-establecimiento="{row}">
                            <span v-if="row.nombre_establecimiento">{{ row.nombre_establecimiento }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-codigo_profesional="{row}">
                            <span v-if="row.cod_profesional">{{ row.cod_profesional }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-nombre_profesional="{row}">
                            <span v-if="row.nombre_profesional">{{ row.nombre_profesional }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-rut_paciente="{row}">
                            <span v-if="row.rut_paciente">{{ row.rut_paciente }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-nombre_paciente="{row}">
                            <span v-if="row.nombre_paciente">{{ row.nombre_paciente }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-tipo_cita="{row}">
                            <span v-if="row.nombre_tipo_cita">{{ row.nombre_tipo_cita }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-especialidad="{row}">
                            <span v-if="row.tipo_atencion">{{ row.tipo_atencion }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>
                          <template v-slot:column-estado="{row}">
                            <span v-if="row.estado">{{ row.estado }}</span>
                            <span v-else class="d-block text-center">-</span>
                          </template>                                       
                        </ServerSideDatatable>                      
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>